import React, { memo } from 'react'

const Progressbar = memo(({compliance=0, title}) => {
  const progressBar = 100 - compliance;
  const isParticipants = title === "Participants Compliance" || title === "Consumers Compliance";
  
  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs font-medium text-gray-600">Progress</span>
        <span className="text-sm font-bold text-gray-700">{compliance}%</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden">
        <div
          className={`
            h-full rounded-full transition-all duration-500 ease-out
            ${isParticipants 
              ? 'bg-gradient-to-r from-purple-500 to-pink-500' 
              : 'bg-gradient-to-r from-green-500 to-emerald-500'
            }
          `}
          style={{ width: `${compliance}%` }}
        >
          <div className="h-full w-full bg-white/20 animate-pulse"></div>
        </div>
      </div>
      {progressBar > 0 && (
        <div 
          className="bg-yellow-400 h-2.5 rounded-r-full -mt-2.5"
          style={{width: `${progressBar}%`, marginLeft: `${compliance}%`}}
        />
      )}
    </div>
  )
});

Progressbar.displayName = 'Progressbar';

export default Progressbar
